import { render, staticRenderFns } from "./layout-image-3x3.vue?vue&type=template&id=5e153a1a&scoped=true&"
import script from "./layout-image-3x3.vue?vue&type=script&lang=js&"
export * from "./layout-image-3x3.vue?vue&type=script&lang=js&"
import style0 from "./layout-image-3x3.vue?vue&type=style&index=0&id=5e153a1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e153a1a",
  null
  
)

export default component.exports